import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import offerPageURL from 'lib/offer/offerPageURL'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'loyalty/constants/base'
import React from 'react'

interface Props {
  offer: Tours.V2Offer | Tours.V2OfferSummary
}

function LuxPlusTourV2AvailableOptionsModal(props: Props) {
  const { offer } = props
  const offerUrl = offerPageURL(offer)

  return <Modal
    title="LuxPlus+ options available"
    primaryActionText="View offer"
    isPrimaryActionHidden={!offerUrl}
    primaryActionTo={offerUrl}
    secondaryActionText={`Learn more about ${LUXURY_PLUS.PROGRAM_NAME}`}
    secondaryActionTo={`/${LUXURY_PLUS_PATHS.LANDING_PAGE}`}
  >
    <BodyText variant="large">
      As a ${LUXURY_PLUS.PROGRAM_NAME} member, you can access exclusive discounts on select tour options,{' '}
      package options, or departure dates for this tour.
    </BodyText>
  </Modal>
}

export default LuxPlusTourV2AvailableOptionsModal
